const EXPIRATION_CHECK_INTERVAL = 2000; // ms
const TOKEN_RENEWAL_THRESHOLD = 10000;

function tokenIsExpiredOrExpiring(expiresAt, current) {
  return expiresAt - current < TOKEN_RENEWAL_THRESHOLD;
}

export default ({ getters, dispatch }) => {
  setInterval(() => {
    if (
      getters.isAccessTokenRefreshable &&
      getters.accessTokenExp &&
      tokenIsExpiredOrExpiring(getters.accessTokenExp * 1000, Date.now())
    ) {
      dispatch('refreshAccessToken');
    }
  }, EXPIRATION_CHECK_INTERVAL);
};
